import type { SVGProps } from 'react';

interface WarningExclaimationProps extends SVGProps<SVGSVGElement> {}

export const WarningExclaimation = (props: WarningExclaimationProps) => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Warning Exclaimation</title>
			<circle cx="40" cy="40" r="34" fill="#FCEDCB" />
			<circle cx="40" cy="39.95" r="26" fill="#9A7614" />
			<circle cx="42" cy="37.95" r="24" fill="#F6C350" />
			<rect
				x="38.708"
				y="21.95"
				width="5"
				height="24"
				rx="2.5"
				fill="#FFF5E5"
			/>
			<rect x="38.208" y="47.95" width="6" height="6" rx="3" fill="#FFF5E5" />
		</svg>
	);
};

export default WarningExclaimation;
